import { render, staticRenderFns } from "./GiftUnbook.vue?vue&type=template&id=0f04c864&scoped=true&"
import script from "./GiftUnbook.vue?vue&type=script&lang=js&"
export * from "./GiftUnbook.vue?vue&type=script&lang=js&"
import style0 from "./GiftUnbook.vue?vue&type=style&index=0&id=0f04c864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04c864",
  null
  
)

export default component.exports